module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAGZJREFUSA1jYBgFoyEwGgLDMAQEBQU9hYSEHgPxIxAb5kVSxWH6GGEMGA0y/P///zIgPiMj4+N3797JgdikioP0gAAThKIdiWEB0PVpQJc/AbkeyE6HWU2qOEzfKD0aAqMhMBxCAABvHTs9R024sQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedback/other.png
// module id = CZTw
// module chunks = 2